module.exports = __webpack_public_path__ + "static/media/distrame8.30293c5d.webp";